import { InputAdornment } from '@mui/material'
import { styled, useTheme } from '../../theme/styled'
import { SearchIcon } from '../icons/SearchIcon'
import { Input } from '../Input'
import * as React from 'react'

const Wrapper = styled.div`
  position: relative;
`

const SuggestedSearchInput = styled(Input)`
  background-color: ${(p) => p.theme.av8.backgroundAlt};
`

const SearchButtonWrapper = styled.div`
  padding: 0 8px;
  z-index: 2;
`
interface SuggestedSearchProps extends Omit<React.HTMLProps<HTMLDivElement>, 'children'> {
  text: string
}

const SuggestedSearch = ({ text, onClick, style }: SuggestedSearchProps) => {
  const theme = useTheme()
  return (
    <Wrapper onClick={onClick} style={style}>
      <SuggestedSearchInput
        value={text.toLowerCase()}
        readOnly
        endAdornment={
          <InputAdornment position='end'>
            <SearchButtonWrapper>
              <SearchIcon color={theme.av8.primaryColor} />
            </SearchButtonWrapper>
          </InputAdornment>
        }
      />
    </Wrapper>
  )
}

export default SuggestedSearch
